import CryptoJS from 'crypto-js'

const ENCRYPTION_KEY = import.meta.env.VITE_STATE_ENCRYPTION_KEY

if (!ENCRYPTION_KEY) {
	console.error('Encryption key is not defined in the environment variables.')
}

const encryptedStorage = {
	getItem: (name) => {
		try {
			const encryptedData = localStorage.getItem(name)
			if (!encryptedData) return null
			const bytes = CryptoJS.AES.decrypt(encryptedData, ENCRYPTION_KEY)
			return JSON.parse(bytes.toString(CryptoJS.enc.Utf8))
		} catch (error) {
			console.error(`Error decrypting data for key "${name}":`, error)
			return null
		}
	},
	setItem: (name, value) => {
		try {
			const encryptedData = CryptoJS.AES.encrypt(
				JSON.stringify(value),
				ENCRYPTION_KEY
			).toString()
			localStorage.setItem(name, encryptedData)
		} catch (error) {
			console.error(`Error encrypting data for key "${name}":`, error)
		}
	},
	removeItem: (name) => {
		try {
			localStorage.removeItem(name)
		} catch (error) {
			console.error(`Error removing key "${name}" from localStorage:`, error)
		}
	}
}

export default encryptedStorage
